import {Observable, Subject} from 'rxjs';
import {Injectable} from '@angular/core';

import {PAPAYA_SLICES} from '../symbols/papaya.symbols';


@Injectable()
export class PapayaControlService {
  private rotateSubject$ = new Subject<void>();
  private resetViewSubject$ = new Subject<void>();
  private toggleDrawSubject$ = new Subject<void>();
  private swapViewSubject$ = new Subject<void>();
  private setViewSubject$ = new Subject<PAPAYA_SLICES>();

  constructor() {
  }

  rotate() {
    this.rotateSubject$.next();
  }

  rotateObservable(): Observable<void> {
    return this.rotateSubject$.asObservable();
  }

  resetView() {
    this.resetViewSubject$.next();
  }

  resetViewObservable(): Observable<void> {
    return this.resetViewSubject$.asObservable();
  }

  toggleDraw() {
    this.toggleDrawSubject$.next();
  }

  toggleDrawObservable(): Observable<void> {
    return this.toggleDrawSubject$.asObservable();
  }

  swapView() {
    this.swapViewSubject$.next();
  }

  swapViewObservable(): Observable<void> {
    return this.swapViewSubject$.asObservable();
  }

  setView(mode: PAPAYA_SLICES) {
    this.setViewSubject$.next(mode);
  }

  setViewObservable(): Observable<PAPAYA_SLICES> {
    return this.setViewSubject$.asObservable();
  }
}
